import React, { useState } from 'react';

function LikeModal({ show, onCancel, onSubmit, partNumber, position }) {
	const [feedbackText, setFeedbackText] = useState('');

	const handleCancel = () => {
		setFeedbackText('');
		onCancel();
	};

	const handleSubmit = () => {
		onSubmit(feedbackText);
		setFeedbackText('');
	};

	if (!show) return null;

	return (
		<>
			{/* Backdrop */}
			<div
				className="fixed inset-0 bg-black/[0.15] z-40"
				onClick={handleCancel}
			/>
			{/* Modal */}
			<div
				className="w-96 p-6 fixed z-50 bg-white rounded-xl shadow-[0px_4px_36.599998474121094px_0px_rgba(0,0,0,0.30)] inline-flex flex-col justify-start items-start gap-6 animate-fade-in"
				style={{
					bottom: `${position.bottom}px`,
					right: `${position.right}px`
				}}
			>
				<div className="w-80 flex flex-col justify-start items-start gap-2">
					<div className="self-stretch justify-center text-neutral-900 text-base font-sf-pro leading-tight">We're glad you found the part you were looking for!</div>
					<div className="justify-center text-neutral-500 text-sm font-normal font-sf-pro leading-tight">Happy to hear that {partNumber || 'N/A'} was a match</div>
				</div>
				<div className="self-stretch flex flex-col justify-start items-start gap-3">
					<div className="justify-center text-neutral-900 text-sm font-sf-pro leading-none">Want to share any additional feedback?</div>
					<div className="self-stretch pl-[5px] pr-px py-px bg-white rounded outline outline-1 outline-offset-[-1px] outline-neutral-200 flex flex-col justify-start items-start">
						<textarea
							value={feedbackText}
							onChange={(e) => setFeedbackText(e.target.value)}
							placeholder="Optional"
							className="self-stretch min-h-24 px-2 pt-1.5 pb-16 flex flex-col justify-start items-start overflow-hidden resize-none focus:outline-none text-neutral-900 text-sm font-normal font-sf-pro leading-tight placeholder:text-neutral-400"
						/>
					</div>
				</div>
				<div className="self-stretch inline-flex justify-end items-center gap-3">
					<button
						onClick={handleCancel}
						className="h-8 px-3 py-1.5 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-neutral-200 flex justify-center items-center hover:bg-gray-50 transition"
						type="button"
					>
						<div className="inline-flex flex-col justify-start items-center">
							<div className="text-center justify-center text-neutral-700 text-sm font-sf-pro leading-tight">Cancel</div>
						</div>
					</button>
					<button
						onClick={handleSubmit}
						className="h-8 px-3 py-1.5 bg-zinc-900 rounded-lg flex justify-center items-center hover:bg-zinc-800 transition"
						type="button"
					>
						<div className="inline-flex flex-col justify-start items-center">
							<div className="text-center justify-center text-white text-sm font-sf-pro leading-tight">Submit Feedback</div>
						</div>
					</button>
				</div>
			</div>
		</>
	);
}

export default LikeModal;
